import { Link } from '@ecomm/framework/Link'

export type BestSystemsProps = {
  readonly title?: string
  readonly description?: string
}

export function BestSystems({
  title = '',
  description = ''
}: BestSystemsProps) {
  const buttons = [
    {
      label: 'Shop packages',
      url: '/home-security-shop-packages'
    },
    {
      label: 'Build your own system',
      url: '/build-my-system'
    }
  ]

  return (
    <div className="md:text-center">
      <h2 className="font-arizona lg:leading-h1-height mb-4 text-[28px] leading-8 lg:text-[55px]">
        {title || 'Shop best security systems'}
      </h2>
      <p className="mx-auto mb-5 text-base md:mb-7 lg:mb-12 lg:w-10/12 lg:px-10 lg:text-lg">
        {description || (
          <>
            We offer sensors for every room, window and door. HD security
            cameras for inside and out. Smarter ways to detect motion. Hazard
            sensors that detect fires, floods, and other threats to your home,
            and powerful sirens that can instantly stop intruders in their
            tracks. All powered by live, 24/7 professional monitoring agents —
            ready to send help fast.
          </>
        )}
      </p>
      <div className="flex flex-col justify-center gap-4 md:flex-row lg:gap-6">
        {buttons.map(({ label, url }) => (
          <Link
            className="border-complementary-blue-100 text-complementary-blue-100 hover:bg-complementary-blue-100 inline-block w-full rounded-lg border-2 border-solid px-4 py-3 text-center text-base font-medium no-underline duration-200 ease-in-out hover:text-white md:mb-0 md:w-[278px] lg:text-lg"
            key={label}
            to={url}
          >
            {label}
          </Link>
        ))}
      </div>
    </div>
  )
}
